import { LazyAction, LazyImport, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "PME" */ './lazyIndex'));

// Delay loaded components
export const PlayMyEmailsPane = createLazyComponent(lazyModule, m => m.PlayMyEmailsPane);
export const PlayMyEmailsOpx = createLazyComponent(lazyModule, m => m.PlayMyEmailsOpx);
export const PlayMyEmailsSuiteHeaderButton = createLazyComponent(
    lazyModule,
    m => m.PlayMyEmailsSuiteHeaderButton
);
export const lazyGetPMEDebugInfo = new LazyImport(lazyModule, m => m.getDebugInfo);
export let lazyCheckIsPMEFeatureEnabled = new LazyImport(lazyModule, m => m.isPMEFeatureEnabled);
export let lazyCheckShouldShowPMEButton = new LazyImport(lazyModule, m => m.shouldShowPMEButton);
export let lazyRefreshPlayMyEmailsEligibility = new LazyAction(
    lazyModule,
    m => m.playMyEmailsEligibilityCheckSync
);
export { playThisConversation } from './actions/playThisConversation';
